import axios from '../axiosConfig';

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = WebApiUrl.replace("localhost", window.location.hostname);

const Godown = {
    insertGodown: async (data) => {
        try {
            const apiUrl = `${WebApiUrl}/api/Godown/Godown`;
            console.log(apiUrl);
            console.log(data);
            const response = await axios.post(apiUrl, {
                name: data.name,
                printName: data.printName,
                stockAmount: Number(data.stockAmount),
                isReflectStockInBalanceSheet: Boolean(data.isReflectStockInBalanceSheet),
                saleAmount: Number(data.saleAmount),
                purchaseAmount: Number(data.purchaseAmount),
                address: data.address,
                isActive: Boolean(data.isActive),
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return true;
        } catch (error) {
            console.error("Error:", error.message);

            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },
    // ************************* Get All ***************************
    getGodown: async () => {
        try {
            const apiUrl = `${WebApiUrl}/api/Godown/GetGodowns`;
            const response = await axios.post(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
        }
    },

     // ************************* Get All ***************************
     getGodownFilter: async () => {
        try {
            const apiUrl = `${WebApiUrl}/api/Godown/GetGodowns`;
            const response = await axios.post(apiUrl, {
                filter: [],
                order: [
                    {
                        propertyName: "id",
                        ascending: false
                    }
                ],
                pageNumber: 0,
                pageSize: 500000
            }, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
        }
    },

    // ************************* Delete ****************************
    deleteGodown: async (godownId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/Godown?godownId=${godownId}`;
            const response = await axios.delete(apiUrl, {
                withCredentials: true,
            });
            console.log('Delete Response:', response.data.result);
            return true;
        } catch (error) {
            console.error('Error:', error.message);
        }
    },

    // ************************* Get By Id ****************************
    getGodownById: async (godownId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/Godown?godownId=${godownId}`;
            const response = await axios.get(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            //setEditCallBack(response.data.result);
            return response.data.result;
        } catch (error) {
            console.error('Error:', error.message);
        }
    },
    // *************************** Update ***************************
    updateGodown: async (data) => {
        console.log(data.id)
        try {
            const apiUrl = `${WebApiUrl}/api/Godown?godownId=${data.id}`;
            console.log(apiUrl);
            const response = await axios.put(apiUrl, {
                id: data.id,
                name: data.name,
                printName: data.printName,
                stockAmount: Number(data.stockAmount),
                isReflectStockInBalanceSheet: Boolean(data.isReflectStockInBalanceSheet),
                saleAmount: Number(data.saleAmount),
                purchaseAmount: Number(data.purchaseAmount),
                address: data.address,
                isActive: Boolean(data.isActive),
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return response.data.isSuccess;
        } catch (error) {
            console.error("Error:", error.message);

            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },

};

export default Godown;
